import * as React from "react";
import { connect } from "react-redux";
import moment from 'moment-timezone';
import * as types from "../../constants/actionTypes";
import MiniSpinner from "../common/MiniSpinner";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import { PROXY_CANCELLED } from "../../constants/textConstants";
import * as ProxyHelper from "./ProxyHelper";
import ProxyStatus from './home/ProxyStatus';
import ErrorMsg from './home/ErrorMsg';

const GRANTCANCELLEDNOTE = "the person granting access has cancelled the request";
const CANCELLEDNOTE = "The request was cancelled.";

class WaitingOnOthers extends React.Component {
    constructor(props) {
        super(props);
        this.state = { requestId: "", isResend: false, isCancel: false }
    }

    componentDidMount() {
        const { proxySource } = this.props;
        if (proxySource && typeof proxySource !== 'undefined') {
            logUI(`MBHWeb.UI.${ProxyHelper.getLogProxySource(proxySource)}.WaitingOnOthers.ComponentDidMount`, new Date(), Tools.getURLPath());
        }
    }

    latestFirst(request1, request2) {
        const a = new Date(request1.LastUpdatedDate);
        const b = new Date(request2.LastUpdatedDate);
        return b > a ? 1 : (a > b ? -1 : 0);
    }

    onCancelRequest(e, requestId, source, type) {
        e.preventDefault();
        const { cancelRequest } = this.props;
        if (cancelRequest) {
            cancelRequest(requestId, source, type, PROXY_CANCELLED);
            this.setState({
                requestId,
                isResend: false,
                isCancel: true
            });
        }
    }

    onResendRequest(e, requestId, source, type) {
        e.preventDefault();
        const { resendRequest } = this.props;
        if (resendRequest) {
            resendRequest(requestId, source, type);
            this.setState({
                requestId,
                isResend: true,
                isCancel: false
            });
        }
    }

    render() {
        let { list, listEpic, grantEpicPendingList, grantPharmacyPendingList, grantEpicCancelledList, grantEpicDeclinedList, grantEpicExpiredList,
            resendAction, cancelAction, grantPharmacyCancelledList, grantPharmacyDeclinedList, grantExpiredPharmacyList, hasRequestEpicCancelledList, requestEpicCancelledList,
            hasRequestEpicExpiredList, requestEpicExpiredList, hasRequestRxCancelledList, requestRxCancelledList, hasRequestRxDeclinedList, requestRxDeclinedList,
            hasRequestRxExpiredList, requestRxExpiredList, hasRequestEpicDeclinedList, requestEpicDeclinedList } = this.props;
        const { requestId, isResend, isCancel } = this.state;
        list = isResend === true || isCancel === true ? list : list && list.sort(this.latestFirst);
        listEpic = isResend === true || isCancel === true ? listEpic : listEpic && listEpic.sort(this.latestFirst);
        //grantEpicPendingList = isResend === true || isCancel === true ? grantEpicPendingList : grantEpicPendingList && grantEpicPendingList.sort(this.latestFirst);
        grantPharmacyPendingList = isResend === true || isCancel === true ? grantPharmacyPendingList : grantPharmacyPendingList && grantPharmacyPendingList.sort(this.latestFirst);


        const spinnerForPending = (<div className="row overlay-loading-container">
            <div className="col-12 align-self-center">
                <MiniSpinner />
            </div>
        </div>);

        return (
            <React.Fragment>
                {/* request pharmacy pending */}
                {list && list.map((request, index) => {
                    let isResendWaiting = isResend && resendAction && resendAction.waiting && resendAction.request && resendAction.request.proxyRequestId === request.ProxyRequestId;
                    let isCancelWaiting = isCancel && cancelAction && cancelAction.waiting && cancelAction.request && cancelAction.request.proxyRequestId === request.ProxyRequestId;
                    let isWaiting = isResendWaiting || isCancelWaiting;
                    let resendErrorMessage = isResend && resendAction && resendAction.error !== null && !resendAction.success && !resendAction.waiting && resendAction.request && resendAction.request.proxyRequestId === request.ProxyRequestId ? (resendAction.errorMessage && resendAction.errorMessage !== null ? resendAction.errorMessage : "We're unable to resend the request. Please try again later.") : "";
                    let resendErrorMsgContent = (!isWaiting && resendErrorMessage) ? <ErrorMsg message={resendErrorMessage} /> : "";
                    let cancelErrorMessage = isCancel && cancelAction && cancelAction.error !== null && !cancelAction.success && !cancelAction.waiting && cancelAction.request && cancelAction.request.proxyRequestId === request.ProxyRequestId ? (cancelAction.errorMessage && cancelAction.errorMessage !== null ? cancelAction.errorMessage : "We're unable to cancel the request. Please try again later.") : "";
                    let cancelErrorMsgContent = (!isWaiting && cancelErrorMessage) ? <ErrorMsg message={cancelErrorMessage} /> : "";
                
                    return (<div className="pending-proxy-list" key={index}>
                        {isWaiting && spinnerForPending}
                        <ProxyStatus
                            iconColor="$color-primary-b1"
                            status={request.Status}
                            message={request.ShowResendOption
                                ? <>Your request for pharmacy access was sent to {request.Email}{' '} on {moment(request.LastUpdatedDate).format('MM/DD/YYYY')} at {moment(request.LastUpdatedDate).format('h:mm A')}.{' '}
                                    This request expires on  <strong>{moment(request.ExpireOn).format('MM/DD/YYYY')}.</strong>
                                </>
                                : <>
                                    Your request for pharmacy access was sent to {request.Email}{' '} on {moment(request.LastUpdatedDate).format('MM/DD/YYYY')} at {moment(request.LastUpdatedDate).format('h:mm A')}.{' '}
                                    {request.ResendProxyAttemptRemaining !== "0" && "You can resend this request after 24 hours of the last submission."} This request expires on <strong>{moment(request.ExpireOn).format('MM/DD/YYYY')}.</strong>
                                </>
                            }
                            link={request.ShowResendOption
                                ? {
                                    label: "Resend",
                                    onClick: (e) => this.onResendRequest(e, request.ProxyRequestId, request.ProxySource, request.RequestType)
                                }
                                : ''}
                            errorMsg={request.ShowResendOption
                                ? <>
                                    {cancelErrorMsgContent}
                                    {resendErrorMsgContent}
                                </>
                                : <>
                                    {cancelErrorMsgContent}
                                </>
                            }
                            circleBtn={{
                                label: "Cancel",
                                onClick: (e) => { this.onCancelRequest(e, request.ProxyRequestId, request.ProxySource, request.RequestType) },
                                tooltipId: `cancel-rx-request-${index}`
                            }}
                        />
                    </div>)
                })
                }

                {/* request v2 epic pending */}
                {
                    listEpic && listEpic.map((request, index) => {
                        let isResendWaiting = isResend && resendAction && resendAction.waiting && resendAction.request && resendAction.request.proxyRequestId === request.ProxyRequestId;
                        let isCancelWaiting = isCancel && cancelAction && cancelAction.waiting && cancelAction.request && cancelAction.request.proxyRequestId === request.ProxyRequestId;
                        let isWaiting = isResendWaiting || isCancelWaiting;
                        let resendErrorMessage = isResend && resendAction && resendAction.error !== null && !resendAction.success && !resendAction.waiting && resendAction.request && resendAction.request.proxyRequestId === request.ProxyRequestId ? (resendAction.errorMessage && resendAction.errorMessage !== null ? resendAction.errorMessage : "We're unable to resend the request. Please try again later.") : "";
                        let resendErrorMsgContent = (!isWaiting && resendErrorMessage) ? <ErrorMsg message={resendErrorMessage} /> : "";

                        let cancelErrorMessage = isCancel && cancelAction && cancelAction.error !== null && !cancelAction.success && !cancelAction.waiting && cancelAction.request && cancelAction.request.proxyRequestId === request.ProxyRequestId ? (cancelAction.errorMessage && cancelAction.errorMessage !== null ? cancelAction.errorMessage : "We're unable to cancel the request. Please try again later.") : "";
                        let cancelErrorMsgContent = (!isWaiting && cancelErrorMessage) ? <ErrorMsg message={cancelErrorMessage} /> : "";
                        return (<div className="pending-proxy-list" key={index}>
                            {isWaiting && spinnerForPending}
                            <ProxyStatus
                                iconColor="$color-primary-b1"
                                status={request.Status}
                                message={request.ShowResendOption
                                    ? <>
                                        Your request to access {request.Email}'s{' '} medical records was sent on {moment(request.LastUpdatedDate).format('MM/DD/YYYY')} at {moment(request.LastUpdatedDate).format('h:mm A')}.{' '}
                                        This request expires on <strong>{moment(request.ExpireOn).format('MM/DD/YYYY')}</strong>.
                                    </>
                                    : <>
                                        Your request to access {request.Email}'s{' '} medical records was sent on {moment(request.LastUpdatedDate).format('MM/DD/YYYY')} at {moment(request.LastUpdatedDate).format('h:mm A')}.{' '}
                                        {request.ResendProxyAttemptRemaining !== "0" && "You can resend this request after 24 hours of the last submission."} This request expires on <strong>{moment(request.ExpireOn).format('MM/DD/YYYY')}.</strong>
                                    </>
                                }
                                link={request.ShowResendOption
                                    ? {
                                        label: "Resend",
                                        onClick: (e) => this.onResendRequest(e, request.ProxyRequestId, request.ProxySource, request.RequestType)
                                    }
                                    : ''}
                                errorMsg={request.ShowResendOption
                                    ? <>
                                        {cancelErrorMsgContent}
                                        {resendErrorMsgContent}
                                    </>
                                    : <>
                                        {cancelErrorMsgContent}
                                    </>
                                }
                                circleBtn={{
                                    label: "Cancel",
                                    onClick: (e) => { this.onCancelRequest(e, request.ProxyRequestId, request.ProxySource, request.RequestType) },
                                    tooltipId: `cancel-medical-request-${index}`
                                }}
                            />
                        </div>)
                    })
                }

                {/* grant pharmacy pending */}
                {
                    grantPharmacyPendingList && grantPharmacyPendingList.map((grant, index) => {
                        let isResendWaiting = isResend && resendAction && resendAction.waiting && resendAction.request && resendAction.request.proxyRequestId === grant.ProxyRequestId;
                        let isCancelWaiting = isCancel && cancelAction && cancelAction.waiting && cancelAction.request && cancelAction.request.proxyRequestId === grant.ProxyRequestId;
                        let isWaiting = isResendWaiting || isCancelWaiting;
                        let resendErrorMessage = isResend && resendAction && resendAction.error !== null && !resendAction.success && !resendAction.waiting && resendAction.request && resendAction.request.proxyRequestId === request.ProxyRequestId ? (resendAction.errorMessage && resendAction.errorMessage !== null ? resendAction.errorMessage : "We're unable to resend the request. Please try again later.") : "";
                        let resendErrorMsgContent = (!isWaiting && resendErrorMessage) ? <ErrorMsg message={resendErrorMessage} /> : "";
/*                     
*/
                        let cancelErrorMessage = isCancel && cancelAction && cancelAction.error !== null && !cancelAction.success && !cancelAction.waiting && cancelAction.request && cancelAction.request.proxyRequestId === grant.ProxyRequestId ? (cancelAction.errorMessage && cancelAction.errorMessage !== null ? cancelAction.errorMessage : "We're unable to cancel the request. Please try again later.") : "";
                        let cancelErrorMsgContent = (!isWaiting && cancelErrorMessage) ? <ErrorMsg message={cancelErrorMessage} /> : "";
                        return (<div className="pending-proxy-list" key={index}>
                            {isWaiting && spinnerForPending}
                            <ProxyStatus
                                iconColor="$color-primary-b1"
                                status={grant.Status}
                                message={grant.ShowResendOption
                                    ? <>
                                        Your request to grant pharmacy access to {grant.Email}{' '} was sent on {moment(grant.LastUpdatedDate).format('MM/DD/YYYY')} at {moment(grant.LastUpdatedDate).format('h:mm A')}.{' '}
                                        This invitation expires on <strong>{moment(grant.ExpireOn).format('MM/DD/YYYY')}</strong>.
                                    </>
                                    : <>
                                        Your request to grant pharmacy access to {grant.Email}{' '} was sent on {moment(grant.LastUpdatedDate).format('MM/DD/YYYY')} at {moment(grant.LastUpdatedDate).format('h:mm A')}.{' '}
                                        {grant.ResendProxyAttemptRemaining !== "0" && "You can resend this invitation after 24 hours of the last submission."} This invitation expires on <strong>{moment(grant.ExpireOn).format('MM/DD/YYYY')}.</strong>
                                    </>
                                }
                                link={grant.ShowResendOption
                                    ? {
                                        label: "Resend",
                                        onClick: (e) => this.onResendRequest(e, grant.ProxyRequestId, grant.ProxySource, grant.RequestType)
                                    }
                                    : ''}
                                errorMsg={grant.ShowResendOption
                                    ? <>
                                        {cancelErrorMsgContent}
                                        {resendErrorMsgContent}
                                    </>
                                    : <>
                                        {cancelErrorMsgContent}
                                    </>
                                }
                                circleBtn={{
                                    label: "Cancel",
                                    onClick: (e) => { this.onCancelRequest(e, grant.ProxyRequestId, grant.ProxySource, grant.RequestType) },
                                    tooltipId: `cancel-rx-grant-${index}`
                                }}
                            />
                        </div>)
                    })
                }
                {/* grant medical records pending */}
                {
                    grantEpicPendingList && grantEpicPendingList.map((grant, index) => {
                        let isResendWaiting = isResend && resendAction && resendAction.waiting && resendAction.request && resendAction.request.proxyRequestId === grant.ProxyRequestId;
                        let isCancelWaiting = isCancel && cancelAction && cancelAction.waiting && cancelAction.request && cancelAction.request.proxyRequestId === grant.ProxyRequestId;
                        let resendErrorMessage = isResend && resendAction && resendAction.error !== null && !resendAction.success && !resendAction.waiting && resendAction.request && resendAction.request.proxyRequestId === grant.ProxyRequestId ? (resendAction.errorMessage && resendAction.errorMessage !== null ? resendAction.errorMessage : "We're unable to resend the request. Please try again later.") : "";
                        let cancelErrorMessage = isCancel && cancelAction && cancelAction.error !== null && !cancelAction.success && !cancelAction.waiting && cancelAction.request && cancelAction.request.proxyRequestId === grant.ProxyRequestId ? (cancelAction.errorMessage && cancelAction.errorMessage !== null ? cancelAction.errorMessage : "We're unable to cancel the request. Please try again later.") : "";
                        let isWaiting = isResendWaiting || isCancelWaiting;
                        let cancelErrorMsgContent = (!isWaiting && cancelErrorMessage) ? <ErrorMsg message={cancelErrorMessage} /> : "";
                        let resendErrorMsgContent = (!isWaiting && resendErrorMessage) ? <ErrorMsg message={resendErrorMessage} /> : "";

                        return (<div className="pending-proxy-list" key={index}>
                            {isWaiting && spinnerForPending}
                            <ProxyStatus
                                iconColor="$color-primary-b1"
                                status={grant.Status}
                                message={grant.ShowResendOption
                                    ? <>
                                        Your request to grant medical record access to {grant.Email}{' '} was sent on {moment(grant.LastUpdatedDate).format('MM/DD/YYYY')} at {moment(grant.LastUpdatedDate).format('h:mm A')}.{' '}
                                        This invitation expires on <strong>{moment(grant.ExpireOn).format('MM/DD/YYYY')}</strong>.
                                    </>
                                    : <>
                                        Your request to grant medical record access to {grant.Email}{' '} was sent on {moment(grant.LastUpdatedDate).format('MM/DD/YYYY')} at {moment(grant.LastUpdatedDate).format('h:mm A')}.{' '}
                                        {grant.ResendProxyAttemptRemaining !== "0" && "You can resend this invitation after 24 hours of the last submission."} This invitation expires on <strong>{moment(grant.ExpireOn).format('MM/DD/YYYY')}</strong>.
                                    </>
                                }
                                link={grant.ShowResendOption
                                    ? {
                                        label: "Resend",
                                        onClick: (e) => this.onResendRequest(e, grant.ProxyRequestId, grant.ProxySource, grant.RequestType)
                                    }
                                    : ''}
                                errorMsg={grant.ShowResendOption
                                    ? <>
                                        {cancelErrorMsgContent}
                                        {resendErrorMsgContent}
                                    </>
                                    : <>
                                        {cancelErrorMsgContent}
                                    </>
                                }
                                circleBtn={{
                                    label: "Cancel",
                                    onClick: (e) => { this.onCancelRequest(e, grant.ProxyRequestId, grant.ProxySource, grant.RequestType) },
                                    tooltipId: `cancel-medical-grant-${index}`
                                }}
                            />
                        </div>);
                    })
                }
                {/* request v2 medical records cancelled*/}
                {
                    hasRequestEpicCancelledList && requestEpicCancelledList && requestEpicCancelledList.map((request, index) =>
                        (<div className="declined-proxy-list" key={index}>
                            <ProxyStatus
                                iconColor="$color-system-b1"
                                status={request.Status}
                                message={request.MessageNote && request.MessageNote.toLowerCase() !== CANCELLEDNOTE.toLowerCase() && request.MessageNote.toLowerCase().indexOf(GRANTCANCELLEDNOTE.toLowerCase()) === -1
                                    ? <>
                                        Your request to access {request.Email}'s medical records has been cancelled.{' '}{request.MessageNote}
                                    </>
                                    : <>
                                        {CANCELLEDNOTE}
                                    </>
                                }
                            /> 
                        </div>)
                    )
                }
                {/* request v2 pharmacy records cancelled*/}
                {
                    hasRequestRxCancelledList && requestRxCancelledList && requestRxCancelledList.map((request, index) =>
                        (<div className="declined-proxy-list" key={index}>
                            <ProxyStatus
                                iconColor="$color-system-b1"
                                status={request.Status}
                                message={request.MessageNote && request.MessageNote.toLowerCase() !== CANCELLEDNOTE.toLowerCase() && request.MessageNote.toLowerCase().indexOf(GRANTCANCELLEDNOTE.toLowerCase()) === -1
                                    ? <>
                                        Your request to access {request.Email}'s pharmacy has been cancelled.{' '}{request.MessageNote}
                                    </>
                                    : <>
                                        {CANCELLEDNOTE}
                                    </>
                                }
                            /> 
                        </div>)
                    )
                }
                {/* grant medical records Cancelled */}
                {
                    grantEpicCancelledList && grantEpicCancelledList.sort(this.latestFirst).map((grant, index) =>
                        (<div className="declined-proxy-list" key={index}>
                            <ProxyStatus
                                iconColor="$color-system-b1"
                                status={grant.Status}
                                message={grant.MessageNote && grant.MessageNote.toLowerCase() !== GRANTCANCELLEDNOTE.toLowerCase() && grant.MessageNote.toLowerCase() !== CANCELLEDNOTE.toLowerCase()
                                    ? <>
                                        Your invitation to grant {grant.Email}{' '} access has been cancelled.{' '}{grant.MessageNote}
                                    </>
                                    : <>
                                        {CANCELLEDNOTE}
                                    </>
                                }
                            />                           
                        </div>)
                    )
                }
                {/* grant pharmacy records cancelled */}
                {
                    grantPharmacyCancelledList && grantPharmacyCancelledList.sort(this.latestFirst).map((grant, index) =>
                        (<div className="declined-proxy-list" key={index}>
                            <ProxyStatus
                                iconColor="$color-system-b1"
                                status={grant.Status}
                                message={grant.MessageNote && grant.MessageNote.toLowerCase() !== GRANTCANCELLEDNOTE.toLowerCase() && grant.MessageNote.toLowerCase() !== CANCELLEDNOTE.toLowerCase()
                                    ? <>
                                        Your invitation to grant {grant.Email}{' '} access has been cancelled.{' '}{grant.MessageNote}
                                    </>
                                    : <>
                                        {CANCELLEDNOTE}
                                    </>
                                }
                            />    
                        </div>)
                    )
                }
                {/* grant medical records declined */}
                {
                    grantEpicDeclinedList && grantEpicDeclinedList.sort(this.latestFirst).map((grant, index) =>
                        (<div className="declined-proxy-list" key={index}>
                            <ProxyStatus
                                iconColor="$color-system-b1"
                                status={grant.Status}
                                message={<>
                                    {grant.Email}{' '} has declined access to your account.
                                </>}
                            />   
                        </div>)
                    )
                }
                {/* request v2 medical records declined */}
                {
                    requestEpicDeclinedList && requestEpicDeclinedList.sort(this.latestFirst).map((request, index) =>
                        (<div className="declined-proxy-list" key={index}>
                            <ProxyStatus
                                iconColor="$color-system-b1"
                                status={request.Status}
                                message={<>
                                    {request.Email}{' '} declined your request for medical record access.
                                </>}
                            />   
                        </div>)
                    )
                }
                {/* request v2 pharmacy records declined */}
                {
                    hasRequestRxDeclinedList && requestRxDeclinedList && requestRxDeclinedList.sort(this.latestFirst).map((request, index) =>
                        (<div className="declined-proxy-list" key={index}>
                            <ProxyStatus
                                iconColor="$color-system-b1"
                                status={request.Status}
                                message={<>
                                    {request.Email}{' '} declined your request for pharmacy access.
                                </>}
                            />  
                        </div>)
                    )
                }
                {/* grant pharmacy records declined */}
                {
                    grantPharmacyDeclinedList && grantPharmacyDeclinedList.sort(this.latestFirst).map((grant, index) =>
                        (<div className="declined-proxy-list" key={index}>
                            <ProxyStatus
                                iconColor="$color-system-b1"
                                status={grant.Status}
                                message={<>
                                    {grant.Email}{' '} has declined access to your account.
                                </>}
                            />  
                        </div>)
                    )
                }

                {/* request v2 pharmacy records expired*/}
                {
                    hasRequestRxExpiredList && requestRxExpiredList && requestRxExpiredList.map((request, index) =>
                        (<div className="declined-proxy-list" key={index}>
                            <ProxyStatus
                                iconColor="$color-system-b1"
                                status={request.Status}
                                message={<>
                                    Your request to access {request.Email}'s pharmacy has expired. It has been more than 30 days since it was sent.
                                </>}
                            />  
                        </div>)
                    )
                }
                {/* request v2 medical records expired*/}
                {
                    hasRequestEpicExpiredList && requestEpicExpiredList && requestEpicExpiredList.map((request, index) =>
                        (<div className="declined-proxy-list" key={index}>
                            <ProxyStatus
                                iconColor="$color-system-b1"
                                status={request.Status}
                                message={<>
                                    Your request to access {request.Email}'s medical records has expired. It has been more than 30 days since it was sent.
                                </>}
                            />  
                        </div>)
                    )
                }
                {/* grant medical records expired */}
                {
                    grantEpicExpiredList && grantEpicExpiredList.sort(this.latestFirst).map((grant, index) =>
                        (<div className="declined-proxy-list" key={index}>
                            <ProxyStatus
                                iconColor="$color-system-b1"
                                status={grant.Status}
                                message={<>
                                    Your invitation to grant {grant.Email}{' '} access has expired. It has been more than 30 days since it was sent.
                                </>}
                            />  
                        </div>)
                    )
                }
                {/* grant pharmacy records expired */}
                {
                    grantExpiredPharmacyList && grantExpiredPharmacyList.sort(this.latestFirst).map((grant, index) =>
                        (<div className="declined-proxy-list" key={index}>
                            <ProxyStatus
                                iconColor="$color-system-b1"
                                status={grant.Status}
                                message={<>
                                    Your invitation to grant {grant.Email}{' '} access has expired. It has been more than 30 days since it was sent.
                                </>}
                            />  
                        </div>)
                    )
                }
                {/* {resendAction &&
                    <div className="col-12 text-sm-center">
                    {resendAction.waiting
                            ? <SectionLoading />
                        : typeof resendAction.error === 'string' && <SectionLoadingError message={resendAction.error} />
                        }
                    </div>
                } */}
            </React.Fragment >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        resendAction: state.common[types.REQUEST_PROXY_RESEND],
        cancelAction: state.common[types.REQUEST_PROXY_CANCEL]
    };
};

const mapDispatchToProps = (dispatch) => ({
    resendRequest: (id, proxySource, requestType) => dispatch({ type: types.REQUEST_PROXY_RESEND, data: { proxyRequestId: id, proxySource, requestType } }),
    cancelRequest: (proxyRequestId, proxySource, requestType, status) => dispatch({ type: types.REQUEST_PROXY_CANCEL, data: { proxyRequestId, proxySource, requestType, status } })
});

export default connect(mapStateToProps, mapDispatchToProps)(WaitingOnOthers);